/*
  Vape Direct quick add for Boost collection and search pages (12 Oct 2026)

  18 Oct 2026: the button is now the same pill as on the native cards (basket icon, "Add", plus),
  and sold out cards show a grey "Sold out" pill. Phone sizing for Boost cards is set in a small
  style block at the bottom of this file, so custom.css did not need changing.

  Adds a round pink button to the right of the price on every Boost product card.
  - Every product opens a small picker inside the card with a quantity selector (- 1 +).
  - Several options (nicotine strength, colour etc.): the picker shows them as buttons too.
  - Shortfills: the picker also asks for the FREE nic shots, exactly like the product page
    (Infinite Options app): 100ml = "1st FREE Nic Shot" and "2nd FREE Nic Shot", 50ml = "FREE Nic Shot",
    each Nic Shot, Ice Shot or Salt Shot. They are sent as the same order notes (line item properties),
    so orders look identical to ones from the product page.
    If those options are ever changed in Infinite Options, update NIC_SHOT_CHOICES and nicShotFields() below.
    29 Oct 2026: the app's three hidden notes are sent too (see IO_BUNDLE_IDS), so the app adds the shots at checkout.
  - Any other shortfill size: the button opens the product page instead.
  - Sold out: grey button that does nothing.
  - Speed: the first row of product photos loads straight away with high priority (Boost marks them all lazy).
  - After adding, an "Added to basket" message drops down under the header by the basket icon
    (a full width bar under the header on phones) and the basket count gives a small bounce.

  Loaded by layout/theme.liquid on collection and search pages only. Styles are in assets/custom.css (vdqa-).
*/
(function () {
  /* Own badges preview (14 Oct 2026): add ?vdbadges=1 to a collection link to see our badges in place of Flair's,
     ?vdbadges=0 to go back. Remembered for the visit. custom.css shows them when html has vd-badges-on. */
  try {
    var vdBadgeParam = new URLSearchParams(window.location.search).get('vdbadges');
    if (vdBadgeParam === '1') sessionStorage.setItem('vdbadges', '1');
    if (vdBadgeParam === '0') sessionStorage.removeItem('vdbadges');
    if (sessionStorage.getItem('vdbadges') === '1') document.documentElement.classList.add('vd-badges-on');
  } catch (e) {}

  if (window.vdQuickAddInit) return;
  window.vdQuickAddInit = true;

  var NIC_SHOT_CHOICES = ['Nic Shot', 'Ice Shot', 'Salt Shot'];

  /* 29 Oct 2026 (Joe and Jack): Infinite Options only adds the free nic shots to the order when the basket line carries
     its own hidden notes, which the product page adds and the quick add did not. Orders 101190 and 101233 went out with
     no shots because of that. The quick add now sends the same three hidden notes, so the app's checkout step treats the
     line exactly like one from the product page. The codes are the app's own ids for the three shot products (the same
     for 100ml and 50ml); if the shot products or the option sets are ever changed in Infinite Options, add a shortfill
     from its product page, look at /cart.js and copy the new codes from _io_product_bundle_ids. */
  var IO_BUNDLE_IDS = {
    'Nic Shot': 'fGZnB3pLdVN4U3ZAaFkxAjEKMxgFNiQWNCA/HyMWZ0IuYGcHLx9xWSwIJEI9XA==',
    'Ice Shot': 'fGZnB3pLdVN7WnBGaV8xAjEKMxgFNiQWNCA/HyMWaUd6ZGxWL0kjWn5adhY8DA==',
    'Salt Shot': 'fGZnB3pLdVN4XHVObV8xAjEKMxgFNiQWNCA/HyMWaBV4YDQLLxxyUnlZdEQ9Cw=='
  };
  function ioHiddenNotes(chosen) {
    var bundles = [], visible = {};
    Object.keys(chosen).forEach(function (field) {
      var v = chosen[field];
      if (v && IO_BUNDLE_IDS[v]) { bundles.push({ bundleId: IO_BUNDLE_IDS[v], name: field }); visible[field] = v; }
    });
    if (!bundles.length) return {};
    return {
      _io_order_group: String(Date.now()),
      _io_product_bundle_ids: JSON.stringify(bundles),
      _io_properties: JSON.stringify(visible)
    };
  }


  function nicShotFields(category) {
    var c = String(category || '').toLowerCase();
    if (c.indexOf('shortfill') === -1) return null;
    if (c.indexOf('100ml') > -1) return ['1st FREE Nic Shot', '2nd FREE Nic Shot'];
    if (c.indexOf('50ml') > -1) return ['FREE Nic Shot'];
    return 'product-page';
  }

  function parse(value) {
    if (typeof value === 'string') {
      try { return JSON.parse(value); } catch (e) { return null; }
    }
    return value;
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text) node.textContent = text;
    return node;
  }

  var ICON_PLUS = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 4v12M4 10h12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var ICON_BASKET = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 7h18l-1.5 10.5a2 2 0 0 1-2 1.5h-11a2 2 0 0 1-2-1.5L3 7z" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/><path d="M8 7a4 4 0 0 1 8 0" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>';
  var PILL_ADD = '<span class="vdqa-btn__icon">' + ICON_BASKET + '</span><span class="vdqa-btn__text">Add</span><span class="vdqa-btn__plus">' + ICON_PLUS + '</span>';
  var ICON_TICK = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M4.5 10.5l3.5 3.5 7.5-8" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- basket ---------- */

  function addToBasket(variantId, properties, quantity) {
    var item = { id: Number(variantId), quantity: Math.max(1, Number(quantity) || 1) };
    if (properties && Object.keys(properties).length) item.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw new Error(json.description || json.message || 'Sorry, that could not be added.');
        return json;
      });
    }).then(function (added) {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* the theme listens for this and updates the basket count in the header */
          window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
          return { added: added, cart: cart };
        });
    });
  }

  /* ---------- toast ---------- */

  var toastTimer = null;
  function showToast(title, variantTitle, cart, quantity) {
    var toast = document.querySelector('.vdqa-toast');
    if (!toast) {
      toast = el('div', 'vdqa-toast');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '';
    var tick = el('span', 'vdqa-toast__tick');
    tick.innerHTML = ICON_TICK;
    var text = el('div', 'vdqa-toast__text');
    text.appendChild(el('strong', null, 'Added to basket'));
    text.appendChild(el('span', null, (quantity > 1 ? quantity + ' x ' : '') + title + (variantTitle ? ' (' + variantTitle + ')' : '')));
    var links = el('div', 'vdqa-toast__links');
    var view = el('a', 'vdqa-toast__view', 'View basket' + (cart && cart.item_count ? ' (' + cart.item_count + ')' : ''));
    view.href = '/cart';
    var checkout = el('a', 'vdqa-toast__checkout', 'Checkout');
    checkout.href = '/checkout';
    links.appendChild(view);
    links.appendChild(checkout);
    toast.appendChild(tick);
    toast.appendChild(text);
    toast.appendChild(links);
    placeToast(toast);
    // restart the drop down animation if it is already showing
    toast.classList.remove('vdqa-toast--show');
    void toast.offsetWidth;
    toast.classList.add('vdqa-toast--show');
    bumpBasketIcon();
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('vdqa-toast--show'); }, 6000);
    // keep it tucked under the header if the page is scrolled while it shows
    if (!toast.vdqaScroll) {
      toast.vdqaScroll = true;
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking || !toast.classList.contains('vdqa-toast--show')) return;
        ticking = true;
        setTimeout(function () { ticking = false; placeToast(toast); }, 50);
      }, { passive: true });
    }
  }

  // The message drops down just under the sticky header, lined up with the basket icon.
  // Measured each time because the header is taller before the announcement bar scrolls away.
  function placeToast(toast) {
    var header = document.querySelector('header.site-header, .site-header');
    var basket = document.querySelector('.site-header-cart');
    var phone = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    var top = phone ? 0 : 12;
    if (header) {
      var hb = header.getBoundingClientRect().bottom;
      // phones: the bar sits flush under the header; bigger screens: a small gap for the pointer
      if (hb > 0) top = Math.round(hb) + (phone ? 0 : 10);
    }
    var right = 20;
    var arrow = 22;
    if (basket) {
      var br = basket.getBoundingClientRect();
      if (br.width) {
        right = Math.max(10, Math.round(document.documentElement.clientWidth - br.right));
        arrow = Math.max(12, Math.round(br.width / 2) - 6);
      }
    }
    toast.style.setProperty('--vdqa-top', top + 'px');
    toast.style.setProperty('--vdqa-right', right + 'px');
    toast.style.setProperty('--vdqa-arrow', arrow + 'px');
  }

  // Small bounce on the header basket count so the eye goes to it.
  function bumpBasketIcon() {
    var count = document.querySelector('.site-header-cart--count, [data-header-cart-count]');
    var target = count || document.querySelector('.site-header-cart');
    if (!target) return;
    target.classList.remove('vdqa-bump');
    void target.offsetWidth;
    target.classList.add('vdqa-bump');
    setTimeout(function () { target.classList.remove('vdqa-bump'); }, 700);
  }

  /* ---------- picker ---------- */

  function closeAllPanels(except) {
    document.querySelectorAll('.vdqa-panel').forEach(function (p) {
      if (p !== except) p.remove();
    });
  }

  function buildPanel(card, info, button) {
    closeAllPanels();
    var panel = el('div', 'vdqa-panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Choose options for ' + info.title);

    var head = el('div', 'vdqa-panel__head');
    var needsChoices = info.variants.length > 1 || Array.isArray(info.nic);
    head.appendChild(el('span', null, needsChoices ? 'Choose options' : 'How many?'));
    var close = el('button', 'vdqa-close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&times;';
    close.addEventListener('click', function () { panel.remove(); button.focus(); });
    head.appendChild(close);
    panel.appendChild(head);

    var chosen = {};       /* option position -> value */
    var nicChosen = {};    /* nic shot field -> choice */
    var hasOptions = info.variants.length > 1;

    /* start on the first variant that is in stock, so one tap on Add is enough for most people */
    var firstAvailable = info.variants.filter(function (v) { return v.available; })[0];
    if (hasOptions && firstAvailable) {
      String(firstAvailable.title).split(' / ').forEach(function (val, i) { chosen[i] = val; });
    }

    var groups = [];
    if (hasOptions) {
      info.options.forEach(function (opt, i) {
        var group = el('div', 'vdqa-group');
        group.appendChild(el('span', 'vdqa-label', opt.label || opt.name));
        var pills = el('div', 'vdqa-pills');
        (opt.values || []).forEach(function (v) {
          var value = v.title;
          var pill = el('button', 'vdqa-pill', value);
          pill.type = 'button';
          pill.dataset.position = i;
          pill.dataset.value = value;
          pill.addEventListener('click', function () {
            chosen[i] = value;
            refresh();
          });
          pills.appendChild(pill);
        });
        group.appendChild(pills);
        panel.appendChild(group);
        groups.push(pills);
      });
    }

    if (Array.isArray(info.nic)) {
      info.nic.forEach(function (field) {
        var group = el('div', 'vdqa-group');
        group.appendChild(el('span', 'vdqa-label', field));
        var pills = el('div', 'vdqa-pills');
        NIC_SHOT_CHOICES.forEach(function (choice) {
          var pill = el('button', 'vdqa-pill vdqa-pill--nic', choice);
          pill.type = 'button';
          pill.dataset.field = field;
          pill.dataset.value = choice;
          pill.addEventListener('click', function () {
            nicChosen[field] = choice;
            refresh();
          });
          pills.appendChild(pill);
        });
        group.appendChild(pills);
        panel.appendChild(group);
      });
    }

    /* quantity: - 1 + (1 to 99) */
    var qty = 1;
    var actions = el('div', 'vdqa-actions');
    var stepper = el('div', 'vdqa-qty');
    var minus = el('button', 'vdqa-qty__btn', '−');
    minus.type = 'button';
    minus.setAttribute('aria-label', 'One less');
    var qtyInput = el('input', 'vdqa-qty__input');
    qtyInput.type = 'number';
    qtyInput.min = '1';
    qtyInput.max = '99';
    qtyInput.value = '1';
    qtyInput.setAttribute('inputmode', 'numeric');
    qtyInput.setAttribute('aria-label', 'Quantity');
    var plus = el('button', 'vdqa-qty__btn', '+');
    plus.type = 'button';
    plus.setAttribute('aria-label', 'One more');
    function setQty(n) {
      qty = Math.min(99, Math.max(1, parseInt(n, 10) || 1));
      qtyInput.value = String(qty);
      minus.disabled = qty <= 1;
    }
    minus.addEventListener('click', function () { setQty(qty - 1); });
    plus.addEventListener('click', function () { setQty(qty + 1); });
    qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });
    stepper.appendChild(minus);
    stepper.appendChild(qtyInput);
    stepper.appendChild(plus);
    setQty(1);

    var add = el('button', 'vdqa-add', 'Add to basket');
    add.type = 'button';
    var msg = el('div', 'vdqa-msg');
    actions.appendChild(stepper);
    actions.appendChild(add);
    panel.appendChild(actions);
    panel.appendChild(msg);

    function matchVariant() {
      if (!hasOptions) return info.variants[0];
      var parts = info.options.map(function (o, i) { return chosen[i]; });
      if (parts.some(function (p) { return p === undefined; })) return null;
      var title = parts.join(' / ');
      return info.variants.filter(function (v) { return v.title === title; })[0] || null;
    }

    function valueAvailable(position, value) {
      /* a value is shown as available if some in-stock variant has it together with the other current choices */
      return info.variants.some(function (v) {
        if (!v.available) return false;
        var parts = String(v.title).split(' / ');
        if (parts[position] !== value) return false;
        return parts.every(function (p, i) { return i === position || chosen[i] === undefined || chosen[i] === p; });
      });
    }

    function refresh() {
      panel.querySelectorAll('.vdqa-pill').forEach(function (pill) {
        if (pill.dataset.field) {
          pill.setAttribute('aria-pressed', nicChosen[pill.dataset.field] === pill.dataset.value ? 'true' : 'false');
        } else {
          var pos = Number(pill.dataset.position);
          pill.setAttribute('aria-pressed', chosen[pos] === pill.dataset.value ? 'true' : 'false');
          pill.classList.toggle('vdqa-pill--unavailable', !valueAvailable(pos, pill.dataset.value));
        }
      });
      var variant = matchVariant();
      var nicMissing = Array.isArray(info.nic) && info.nic.some(function (f) { return !nicChosen[f]; });
      msg.textContent = '';
      if (variant && !variant.available) {
        add.disabled = true;
        add.textContent = 'Sold out';
      } else if (!variant) {
        add.disabled = true;
        add.textContent = 'Choose an option';
      } else if (nicMissing) {
        add.disabled = true;
        add.textContent = info.nic.length > 1 ? 'Choose your free nic shots' : 'Choose your free nic shot';
      } else {
        add.disabled = false;
        add.textContent = 'Add to basket';
      }
    }

    add.addEventListener('click', function () {
      var variant = matchVariant();
      if (!variant) return;
      add.disabled = true;
      add.textContent = 'Adding...';
      var props = {};
      if (Array.isArray(info.nic)) info.nic.forEach(function (f) { props[f] = nicChosen[f]; });
      if (Array.isArray(info.nic)) { var ioNotes = ioHiddenNotes(props); Object.keys(ioNotes).forEach(function (k) { props[k] = ioNotes[k]; }); }
      setQty(qtyInput.value);
      addToBasket(variant.id, props, qty).then(function (res) {
        panel.remove();
        markDone(button);
        showToast(info.title, hasOptions ? variant.title : '', res.cart, qty);
      }).catch(function (err) {
        msg.textContent = err.message;
        refresh();
      });
    });

    /* clicks inside the picker must not reach Boost (which would open the product) */
    ['click', 'mousedown', 'touchstart'].forEach(function (type) {
      panel.addEventListener(type, function (e) { e.stopPropagation(); }, { passive: type === 'touchstart' });
    });

    card.appendChild(panel);
    refresh();
    var firstControl = panel.querySelector('.vdqa-pill, .vdqa-add');
    if (firstControl) firstControl.focus({ preventScroll: true });
  }

  function markDone(button) {
    button.classList.add('vdqa-btn--done');
    button.innerHTML = '<span class="vdqa-btn__icon">' + ICON_TICK + '</span><span class="vdqa-btn__text">Added</span>';
    setTimeout(function () {
      button.classList.remove('vdqa-btn--done');
      button.innerHTML = PILL_ADD;
    }, 2000);
  }

  /* ---------- cards ---------- */

  function enhance(card) {
    if (card.getAttribute('data-vdqa')) return;
    var raw = card.getAttribute('data-product');
    var price = card.querySelector('.boost-sd__product-price');
    if (!raw || !price) return;
    card.setAttribute('data-vdqa', '1');

    var data;
    try { data = JSON.parse(raw); } catch (e) { return; }
    var variants = parse(data.variants) || [];
    if (!variants.length) return;
    var titleEl = card.querySelector('.boost-sd__product-title');
    var info = {
      handle: data.handle,
      title: titleEl ? titleEl.textContent.trim() : '',
      variants: variants,
      options: (parse(data.options_with_values) || []).slice().sort(function (a, b) { return (a.position || 0) - (b.position || 0); }),
      nic: nicShotFields(data.category)
    };
    var inStock = variants.some(function (v) { return v.available; });

    var button = el('button', 'vdqa-btn vdqa-btn--pill');
    button.type = 'button';
    button.innerHTML = PILL_ADD;
    if (!inStock) {
      button.disabled = true;
      button.classList.add('vdqa-btn--soldout');
      button.innerHTML = '<span class="vdqa-btn__text">Sold out</span>';
      button.setAttribute('aria-label', info.title + ' is sold out');
      button.title = 'Sold out';
    } else {
      button.setAttribute('aria-label', 'Add to basket: ' + info.title);
      button.title = 'Add to basket';
    }

    price.classList.add('vdqa-price-row');
    price.appendChild(button);

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (button.disabled) return;
      if (info.nic === 'product-page') {
        window.location.href = '/products/' + info.handle;
        return;
      }
      var open = card.querySelector('.vdqa-panel');
      if (open) { open.remove(); return; }
      buildPanel(card, info, button);
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.boost-sd__product-item[data-product]').forEach(enhance);
  }

  /* Photo load priority (13 Oct 2026) now lives in Boost's own card template
     (Boost app, theme editor, product-item/product-image.liquid): first row high priority,
     second row loads straight away, the rest lazy. Nothing to do here. */

  /* Phone filter drawer (14 Oct 2026): open with every section closed, so it reads as a tidy list of headings.
     Boost has a "collapse on mobile" switch on every single filter option, which is too many to set by hand,
     so it is done here instead. It presses Boost's own open/close button so Boost's state stays correct.
     A section stays open if the shopper opened it, or if one of its options is ticked.
     Only runs on phone widths and only in Boost's "Scroll down - Fullwidth" layout, where each section has an
     open/close state. In the other layouts the sections carry a --hidden class and are left alone. */
  var MOBILE_FILTER_MAX = 767;
  var filterOpenedByShopper = {};
  var autoClosed = {};

  document.addEventListener('click', function (e) {
    if (!e.isTrusted || !e.target.closest) return;
    var title = e.target.closest('#boost-sd_filter-tree-mobile .boost-sd__filter-option-title');
    if (!title) return;
    var option = title.closest('.boost-sd__filter-option');
    var label = title.closest('.boost-sd__filter-option-label');
    var id = option && option.getAttribute('data-filteroptionid');
    if (!id || !label) return;
    // this runs before Boost's own handler: a closed section is about to open, an open one is about to close
    filterOpenedByShopper[id] = label.classList.contains('boost-sd__filter-option-label--collapsed');
  }, true);

  function closeMobileFilterSections() {
    if (window.innerWidth > MOBILE_FILTER_MAX) return;
    var drawer = document.getElementById('boost-sd_filter-tree-mobile');
    if (!drawer) return;
    // accordion layout shows every section at once; if any are still hidden the drawer is shut or in the old layout
    if (drawer.querySelector('.boost-sd__filter-option-itemwrapper--hidden')) return;
    drawer.querySelectorAll('.boost-sd__filter-option').forEach(function (option) {
      var id = option.getAttribute('data-filteroptionid');
      var label = option.querySelector('.boost-sd__filter-option-label');
      var title = label && label.querySelector('.boost-sd__filter-option-title');
      if (!id || !title) return;
      if (label.classList.contains('boost-sd__filter-option-label--collapsed')) return;
      if (filterOpenedByShopper[id]) return;
      if (option.querySelector('[aria-checked="true"]')) return;
      // safety cap, in case Boost keeps reopening a section itself
      autoClosed[id] = (autoClosed[id] || 0) + 1;
      if (autoClosed[id] > 5) return;
      title.click();
    });
  }

  /* Boost builds the drawer's sections hidden and only shows them when the drawer opens, by changing a class,
     so the drawer itself is watched for class changes as well as new content (14 Oct 2026). */
  var watchedDrawer = null;
  var drawerObserver = new MutationObserver(function () { closeMobileFilterSections(); });
  function watchMobileDrawer() {
    var drawer = document.getElementById('boost-sd_filter-tree-mobile');
    if (!drawer || drawer === watchedDrawer) return;
    drawerObserver.disconnect();
    watchedDrawer = drawer;
    drawerObserver.observe(drawer, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.boost-sd__filter-tree-toggle-button')) return;
    [0, 150, 400].forEach(function (ms) {
      setTimeout(function () { watchMobileDrawer(); closeMobileFilterSections(); }, ms);
    });
  });

  /* Boost redraws the grid on filter, sort and page changes, so watch for new cards */
  var queued = false;
  var observer = new MutationObserver(function () {
    watchMobileDrawer();
    closeMobileFilterSections();
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 60);
  });

  function start() {
    scan();
    watchMobileDrawer();
    closeMobileFilterSections();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPanels();
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.vdqa-panel, .vdqa-btn')) closeAllPanels();
  });

  /* phone sizing for the pill on Boost cards (two narrow columns) */
  try {
    var pillStyle = document.createElement('style');
    pillStyle.textContent = '.vdqa-btn--done .vdqa-btn__icon svg{width:15px;height:15px}' +
      '@media(max-width:767px){.boost-sd__product-item .vdqa-btn.vdqa-btn--pill{height:32px;padding:0 9px;font-size:12px;gap:5px}' +
      '.boost-sd__product-item .vdqa-btn--pill .vdqa-btn__icon svg{width:15px;height:15px}' +
      '.boost-sd__product-item .vdqa-btn--pill .vdqa-btn__plus svg{width:12px;height:12px}}';
    document.head.appendChild(pillStyle);
  } catch (e) {}

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
